import { Box, ButtonBase, Typography } from "@mui/material";
import { MdArrowForward } from "react-icons/md";

import type { HomeMovement } from "../types/home.types";
import { movementTimeLabel } from "../utils/homeFilters";
import { HomeChip, StatusChip, statusLabel } from "./HomeChip";
import { HomePanel } from "./HomePanel";
import { HOME_COLORS, statusTone } from "./homeTheme";

interface MovementsPanelProps {
  today?: string;
  movements?: HomeMovement[];
  /** Na visão Todos, cada movimentação mostra também a célula. */
  showCell: boolean;
  onOpenProject(projectId: string): void;
}

/** Mudanças de status das últimas 24h no escopo (no máximo 7). */
export function MovementsPanel({
  today,
  movements,
  showCell,
  onOpenProject,
}: MovementsPanelProps) {
  return (
    <HomePanel
      title="Movimentações recentes"
      aside="Últimas 24h"
      flex="1 1 300px"
    >
      <Box display="flex" flexDirection="column">
        {movements && movements.length === 0 && (
          <Typography sx={{ py: 2, color: HOME_COLORS.muted, fontSize: 13 }}>
            Nenhuma mudança de status nas últimas 24h.
          </Typography>
        )}
        {(movements ?? []).map((movement) => (
          <ButtonBase
            key={movement.id}
            onClick={() => onOpenProject(movement.projectId)}
            sx={{
              display: "grid",
              gridTemplateColumns: "76px minmax(0, 1fr)",
              alignItems: "start",
              gap: 1.25,
              py: 1.4,
              px: 0.5,
              textAlign: "left",
              borderTop: `1px solid ${HOME_COLORS.line}`,
              "&:hover": { bgcolor: HOME_COLORS.soft },
            }}
          >
            <Typography
              sx={{ fontSize: 12, color: HOME_COLORS.muted, pt: "2px" }}
            >
              {today ? movementTimeLabel(movement.date, today) : ""}
            </Typography>
            <Box display="flex" flexDirection="column" minWidth={0}>
              <Typography sx={{ fontSize: 13 }}>
                <b>
                  {movement.mmCode}/{movement.yearCode}
                </b>
                {` · ${movement.userName ?? "Usuário não identificado"}`}
                {showCell && movement.cellName ? ` · ${movement.cellName}` : ""}
              </Typography>
              <Box
                display="flex"
                alignItems="center"
                flexWrap="wrap"
                gap={0.75}
                mt={0.75}
              >
                {/* O status anterior fica em cinza; o novo leva a cor dele. */}
                <HomeChip
                  label={
                    movement.from
                      ? statusLabel(movement.from)
                      : "Sem status anterior"
                  }
                  tone={statusTone(null)}
                />
                <Box display="flex" sx={{ color: HOME_COLORS.muted }}>
                  <MdArrowForward size={14} aria-label="para" />
                </Box>
                <StatusChip status={movement.to} />
              </Box>
            </Box>
          </ButtonBase>
        ))}
      </Box>
    </HomePanel>
  );
}
